import Axios from 'axios';
import { baseUrl, requestHeader } from '../../config';
import { CatchReturnError } from './actionHandler';

interface sellDomainData {
  name: string;
  email: string;
  phone: string;
  domain: string;
  price?: number;
  minQuote?: number;
  comment?: string;
  source?: string;
  value?: number;
  worth?: number;
  formName?: string;
}

export const postSellDomain = async (data: sellDomainData) => {
  try {
    const res = await Axios.post(baseUrl + '/sell-domain', data);
    return res.data;
  } catch (error) {
    CatchReturnError(error);
    return false;
  }
};

export const postSellCSVUpload = async (query: string, file: File | string) => {
  const files = new FormData();
  if (typeof file !== 'string') files.append('file', file);
  try {
    const res = await Axios.post(baseUrl + '/sell-csv' + query, files, { headers: { 'Content-Type': 'multipart/form-data' } });
    return res.data;
  } catch (error) {
    CatchReturnError(error);
    return false;
  }
};

export const postSellComment = async (id: string, data: { comment: string }) => {
  try {
    const res = await Axios.post(baseUrl + '/sell-comment/' + id, data);
    return res.data;
  } catch (error) {
    CatchReturnError(error);
    return false;
  }
};

export const postSellPremiumDomain = async (data: sellDomainData) => {
  try {
    const res = await Axios.post(baseUrl + '/sell-premium-domain', data);
    return res.data;
  } catch (error) {
    CatchReturnError(error);
    return false;
  }
};

export const getSellDomainList = async (query: string) => {
  try {
    const res = await Axios.get(baseUrl + '/sellerDomainList' + query, requestHeader);
    return res.data;
  } catch (error) {
    CatchReturnError(error);
    return false;
  }
};
